<template>
  <div class="content">
    <div v-if="noSet" class="no-set">
      <slot name="no-set" />
    </div>
    <template v-else v-for="(name, key) in order">
      <div v-if="$slots[name]" :class="name" :key="key">
        <slot :name="name" />
      </div>
    </template>
  </div>
</template>

<script>
const slots = ['unit', 'graph', 'table', 'action']

export default {
  name: 'AnalysisContent',
  props: {
    order: {
      type: Array,
      required: false,
      default: () => slots,
      validator: order => order.every(name => slots.includes(name)),
    },
    noSet: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {}
  },
  computed: {},
  methods: {},
}
</script>

<style lang="postcss" scoped>
.content {
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  padding: 32px;

  & > * + * {
    margin-top: 16px;
  }

  .graph {
    background: var(--white);
    box-sizing: border-box;
    min-height: 488px;
    overflow-x: hidden;
    padding: 24px;
  }

  .no-set {
    align-items: center;
    background: var(--white);
    display: flex;
    flex-direction: column;
    font-size: 14px;
    height: 488px;
    justify-content: center;
    text-align: center;
  }
}
</style>
